module.exports = __webpack_public_path__ + "static/media/Season.d6676cf3.svg";